import actions from '../actions/actions';

const INITIAL_STATE = {
  openedFile: null,
  createNotice: {
    popupOpened: false,
    page: 0,
    lastPage: 0,
  },
  files: [],
  listLoading: false,
  filter: {},
  filterIsWorked: false,
  debtsListLoading: true,
  debts: [],
  debtorStates: {},
  noticeStates: {},
  currentCompany: null,
  visibleModal: null,
  alertUrl: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.SET_CURRENT_COMPANY:
      return {
        ...state,
        currentCompany: action.payload,
      };
    case actions.SET_ALERT_URL:
      return {
        ...state,
        alertUrl: action.payload,
      };
    case actions.SET_VISIBLE_MODAL:
      return {
        ...state,
        visibleModal: action.payload,
      };
    case actions.OPENED_FILE:
      return {
        ...state,
        openedFile: action.payload,
      };
    case actions.NOTIFICATION_STATES_LOADED:
      return {
        ...state,
        noticeStates: action.payload.reduce((acc, type) => {
          acc[type.id] = type.name;
          return acc;
        }, {}),
      };
    case actions.DEBTOR_STATES_LOADED:
      return {
        ...state,
        debtorStates: action.payload.reduce((acc, type) => {
          acc[type.id] = type.name;
          return acc;
        }, {}),
      };
    case actions.CREATE_NOTIFICATION_SETTINGS:
      return {
        ...state,
        createNotice: {
          ...state.createNotice,
          ...action.payload,
        },
      };
    case actions.CREATE_NOTIFICATION_TYPE_SETTINGS:
      return {
        ...state,
        createNotice: {
          ...state.createNotice,
          [action.payload.type]: {
            ...state.createNotice[action.payload.type],
            ...action.payload,
          },
        },
      };
    case actions.CREATE_NOTIFICATION_POPUP_STATE:
      if (action.payload.popupOpened === false) {
        return {
          ...state,
          createNotice: {
            popupOpened: false,
            page: 0,
            lastPage: 0,
          },
        };
      }

      return {
        ...state,
        createNotice: {
          ...state.createNotice,
          ...action.payload,
        },
      };
    case actions.LIST_LOADING:
      return {
        ...state,
        listLoading: true,
      };
    case actions.FILE_LIST_LOADED:
      return {
        ...state,
        listLoading: false,
        files: action.payload,
      };
    case actions.NOTIFICATION_LIST_LOADED:
      return {
        ...state,
        listLoading: false,
        files: state.files.map((file) => {
          return {
            ...file,
            notices: action.payload?.notices.filter((notice) => {
              return +notice.fileId === +file?.fileId;
            }),
          };
        }),
        openedFile: {
          ...state.openedFile,
          notices: action.payload?.notices.filter((notice) => {
            return +notice.fileId === +state.openedFile?.fileId;
          }),
        },
      };
    case actions.FILTER_SETTINGS:
      return {
        ...state,
        filter: { ...state.filter, ...action.payload },
        filterIsWorked: false,
      };
    case actions.DELETE_FILTER:
      return {
        ...state,
        filter: {},
        filterIsWorked: false,
      };

    case actions.FILTER_WORKED:
      return {
        ...state,
        filterIsWorked: action.payload,
      };
    case actions.DEBTS_LIST_LOADING:
      return {
        ...state,
        debtsListLoading: true,
      };
    case actions.DEBTS_LIST_LOADED:
      return {
        ...state,
        debts: action.payload.map((debt) => {
          if (debt.stateId) {
            debt.state = state.debtorStates[debt.stateId];
          }
          return debt;
        }),
        debtsListLoading: false,
      };
    default:
      return state;
  }
};
